import React, {Component} from 'react';
import {Button, Dropdown, Icon, Modal, Grid, Segment,Header,Popup} from "semantic-ui-react";
import {getRoomTemplateList,deleteRoomTemplate} from "../../../../data/report_api";
import ViewClerkRoomTemplateDetail from "./room_template_detail";

class RoomTemplateList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            viewTemplate: false,
            roomTemplates: [  ...(!this.props.other_template ? [{
                key: 1,
                value: 1,
                text: "Default - Gardens",
                additionalcontent: "[{\"name\":\"Gardens\",\"groups\":[{\"name\":\"Floor\",\"items\":[]},{\"name\":\"Boundaries\",\"items\":[]},{\"name\":\"Contents and Fittings\",\"items\":[]},{\"name\":\"Shed\",\"items\":[]}]}]",
            },
            {
                key: 2,
                value: 2,
                text: "Default - Standard Room",
                additionalcontent:"[{\"name\":\"Standard Room\",\"groups\":[{\"name\":\"Door\",\"items\":[]},{\"name\":\"Floor\",\"items\":[]},{\"name\":\"Walls\",\"items\":[]},{\"name\":\"Ceiling\",\"items\":[]},{\"name\":\"Fixtures and Fittings\",\"items\":[]},{\"name\":\"Furnishings\",\"items\":[]},{\"name\":\"Cupboard\",\"items\":[]},{\"name\":\"Window\",\"items\":[]}]}]",
            },
            {
                key: 3,
                value: 3,
                text: "Default - Kitchen",
                additionalcontent: "[{\"name\":\"Kitchen\",\"groups\":[{\"name\":\"Door\",\"items\":[]},{\"name\":\"Floor\",\"items\":[]},{\"name\":\"Walls\",\"items\":[]},{\"name\":\"Ceiling\",\"items\":[]},{\"name\":\"Fixtures and Fittings\",\"items\":[]},{\"name\":\"Furnishings\",\"items\":[]},{\"name\":\"Units\",\"items\":[]},{\"name\":\"Sink\",\"items\":[]},{\"name\":\"Worktop\",\"items\":[]},{\"name\":\"Appliances\",\"items\":[]},{\"name\":\"Manuals\",\"items\":[]},{\"name\":\"Cupboard\",\"items\":[]},{\"name\":\"Window\",\"items\":[]},{\"name\":\"Rear Door\",\"items\":[]}]}]",

            },
            {
                key: 4,
                value: 4,
                text: "Default - Bathroom",
                additionalcontent:"[{\"name\":\"Bathroom\",\"groups\":[{\"name\":\"Door\",\"items\":[]},{\"name\":\"Floor\",\"items\":[]},{\"name\":\"Walls\",\"items\":[]},{\"name\":\"Ceiling\",\"items\":[]},{\"name\":\"Fixtures and Fittings\",\"items\":[]},{\"name\":\"Furnishings\",\"items\":[]},{\"name\":\"Sanitary Ware\",\"items\":[]},{\"name\":\"Cupboard\",\"items\":[]},{\"name\":\"Window\",\"items\":[]}]}]",
            }]:[])
        ],
            selectedTemplate: undefined,
            templateDetail: undefined,
            popupOpen:false
        }
    }

    componentWillMount() {
        this.refreshRoomTemplateList()
    }
    
    deleteRoomTemplate = (selectedTemplate) => {
        deleteRoomTemplate(selectedTemplate).then(() => {
        this.clearTemplateData();
        this.refreshRoomTemplateList();})
    }

    clearTemplateData = () => {
        this.setState({ viewTemplate: false, roomTemplates: [], selectedTemplate: undefined, templateDetail: undefined,popupOpen:false })
    }

    refreshRoomTemplateList = () => {
        getRoomTemplateList().then((response) => {
            if (response.success) {
                let newObj = [...this.state.roomTemplates];
                const roomTemplates = response.data;
                const listsLength = roomTemplates.length;
                for (let i = 0; i < listsLength; i++) {
                    let obj = {
                        key: roomTemplates[i].id,
                        text: roomTemplates[i].name,
                        value: roomTemplates[i].id,
                        additionalcontent: roomTemplates[i].content,
                    };
                    newObj.push(obj);
                }
                this.setState({roomTemplates: newObj});
            }
        })
    }

    render() {
        return (
            <Modal size={this.state.viewTemplate ? "small" : "tiny"} open={true} onClose={(e) => {
                this.props.showLoadRoomTemplate(false);
            }}>
                <Modal.Header>Available Room Templates</Modal.Header>
                <Modal.Content style={{paddingTop: '0'}}>
                    <div className="modal-close-button">
                        <Button basic icon negative onClick={(e) => {
                            this.props.showLoadRoomTemplate(false);
                        }}><Icon name="close"/></Button>
                    </div>
                    <Modal.Description>
                        <Grid>
                            {<Grid.Column width={this.state.viewTemplate ? 6 : 16}>
                                <Dropdown
                                    placeholder='Search Template'
                                    fluid
                                    icon="search"
                                    onChange={(e, option) => {
                                        const selection = option.options.filter((e) => {
                                            return e.key === option.value;
                                        });
                                        this.setState({
                                            selectedTemplate: option.value,
                                            templateDetail: selection[0]['additionalcontent'],
                                            viewTemplate:true
                                        })
                                    }}
                                    value={this.state.selectedTemplate}
                                    search
                                    noResultsMessage="Room template not found"
                                    selection
                                    options={this.state.roomTemplates}
                                />
                                <div className="pad-top" style={{height: '300px', overflow: 'auto'}}>
                                    {this.state.roomTemplates.length > 0 &&
                                    <Segment.Group>
                                        {this.state.roomTemplates.map((template, i) => {
                                            return (
                                                <Segment key={"template-" + i}
                                                         className={this.state.selectedTemplate === template.key?"format-capitalize icon-button tile-selected":"format-capitalize icon-button"} onClick={() => {
                                                    this.setState({
                                                        viewTemplate: true,
                                                        selectedTemplate:template.key,
                                                        templateDetail: template.additionalcontent
                                                    })
                                                }}>
                                                    {template.text}
                                                </Segment>
                                            );
                                        })}
                                    </Segment.Group>}
                                </div>
                            </Grid.Column>}
                            {this.state.viewTemplate &&
                            <Grid.Column width={10}>
                                {this.state.templateDetail &&<div>
                                    <Header content="Template Details" textAlign="center"/>
                                    <div style={{height:'250px',overflow:'auto'}}>
                                        <ViewClerkRoomTemplateDetail roomObject={JSON.parse(this.state.templateDetail)}/>
                                    </div>
                                </div>}
                            </Grid.Column>}
                        </Grid>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={() => {
                        this.props.showLoadRoomTemplate(false);
                    }}/>
                <Popup 
                    trigger={<Button color="red" onClick={ () => {this.setState({popupOpen:true})}}disabled={!this.state.selectedTemplate}> Delete Selected Template </Button>}
                    content={<div>
                             <p>Are you sure?</p>
                             <Button negative content='Delete Selected Template'
                                          onClick={()=>{this.deleteRoomTemplate(this.state.selectedTemplate);}}/>
                            </div>}
                    on='click'
                    position='right center'
                    hideOnScroll
                    open={this.state.popupOpen}
                    disabled={!this.state.selectedTemplate}/>
                    <Button primary onClick={()=>{this.props.loadTemplate(JSON.parse(this.state.templateDetail)[0])}} disabled={!this.state.selectedTemplate}>
                        Load Selected Template
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default RoomTemplateList;


// WEBPACK FOOTER //
// ./src/views/report/templates/clerk/room_template_list.js